import { removeQueryParameter } from './removeQueryParameter'

/**
 * Get the specified key from the query parameters if present and optionally remove it from the URL.
 */
export function getQueryParameter(parameter: string, remove: boolean = false, fallback: string = ''): string {
  const query = new URLSearchParams(globalThis.location.search)
  const foundValue = query.get(parameter) ? `${query.get(parameter)}` : undefined

  if (foundValue && remove) {
    removeQueryParameter(parameter)
  }

  return foundValue || fallback
}
